import RestService from './RestService';

export default class SpeechService extends RestService {
    constructor() {
        super('/speech');
    }
}
